module.exports = __webpack_public_path__ + "dcd721ca73a87ff4fba44aac68789306.svg";